import {bloqueaTabulador} from "../lib/menu";

const telefonos = () => {
    Array.from(document.querySelectorAll<HTMLElement>('.bloque--telefonos')).forEach((bloque) => {
        const botones = Array.from(bloque.querySelectorAll<HTMLElement>('button'));

        const popup = document.querySelector<HTMLElement>('#' + bloque.dataset.formulario!)!;
        const cantidades = popup.querySelector<HTMLFieldSetElement>('.cantidades__fieldset');
        const radioVacio = cantidades?.querySelector<HTMLInputElement>('input[type="radio"][value=""]');


        bloqueaTabulador(popup);

        const muestraPopup = (cantidad: string) => (e: MouseEvent) => {
            e.preventDefault();

            popup.style.opacity = '1';

            if (cantidades && cantidad) {
                let radio = popup.querySelector<HTMLInputElement>(`input[type="radio"][value="${cantidad}"]`);

                if (radio) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', {bubbles: true}));
                } else if (cantidad && radioVacio) {
                    const inputCantidad = cantidades?.querySelector<HTMLInputElement>('input[type="text"]');
                    if (inputCantidad) {
                        inputCantidad.value = cantidad;
                    }

                    radioVacio.checked = true;
                    radioVacio.dispatchEvent(new Event('change', {bubbles: true}));
                }
            }
        }

        const ocultaPopup = () => popup.style.opacity = '0'

        botones.forEach((boton) => boton.addEventListener('click', muestraPopup(boton.dataset.cantidad || '')));

        popup.addEventListener('transitionend', (e) => {
            if (e.target !== popup) return;

            if (getComputedStyle(popup).opacity === '0') {
                popup.hidden = true;
                popup.inert = true;
                popup.style.opacity = '';
            } else {
                popup.hidden = false;
                popup.inert = false;
                popup.querySelector<HTMLElement>('input[type="text"]:not(.pueseso)')?.focus();
            }
        });

        if (popup.querySelector('.formulario__gracias__mensaje') || popup.querySelector('.formulario__error')) {
            addEventListener('load', () => popup.style.opacity = '1');
            popup.addEventListener('transitionend', () => {
                if (getComputedStyle(popup).opacity === '0') {
                    location.href = location.href.replace(/gracias.*/, '');
                }
            });
        }

        popup.addEventListener('click', (event) => {
            if (event.target === popup) {
                ocultaPopup();
            }
        });

        addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && getComputedStyle(popup).opacity !== '0') {
                ocultaPopup();
            }
        });
    });
}

export default telefonos;